import _ from 'underscore';
import { useState, useEffect } from 'react';
import odata from '@bingads-webui-component-legacy/http/channel/odata';
import instrumentationSettings from '@bingads-webui-static-legacy/instrumentation/campaignSchemaAndSetting';
import { useDashboardPreferences } from '@bingads-webui-campaign/overview-welcome-tips-card';

const userWelcomePrefName = 'doneWithWelcomeTips';
let doneInitialLoad = false;
function uri() {
  const api = 'Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.AlertInformation';
  const odataParam = '$select=HasBIData,HasCampaigns,HasOtherAccounts';

  return `${api}?${odataParam}`;
}

export const useWelcomeTips = ({
  preference, navigationLevel, serverContext, instrumentation, constants,
}) => {
  const { WelcomeStatus } = serverContext;

  const [welcomeTipsStatus, setWelcomeTipsStatus] = useState();
  const { options, saveDashBoardOptions } = useDashboardPreferences({ preference, navigationLevel });

  const userWelcomePref = preference.findByNameAtUserLevel(userWelcomePrefName);

  useEffect(() => {
    if (welcomeTipsStatus) {
      return;
    }

    let cancel = false;
    const doNotShowWelcomeTips = navigationLevel !== 'account' || _.get(userWelcomePref, 'Data', false) === true;

    const welcomeStatus = new Promise((resolve) => {
      if (doNotShowWelcomeTips) {
        resolve({ showWelcomeTips: false });
      } else if (WelcomeStatus && !doneInitialLoad) {
        resolve({
          showWelcomeTips: WelcomeStatus.ShowWelcomeTips,
          createdCampaign: WelcomeStatus.HasCampaigns,
          skippedBothAtAccountCreation: options.skippedBothAtAccountCreation,
          skippedNoneAtAccountCreation: options.skippedNoneAtAccountCreation,
        });
        // If it is not first page loading scenario, we should go to else block.
        // we have to delay the flag update here because the hook will be called
        // multiple times during the page loading.
        setTimeout(() => {
          doneInitialLoad = true;
        }, 3000);
      } else {
        odata.get(uri()).then((data) => {
          if (data.HasBIData || data.HasOtherAccounts) {
            resolve({ showWelcomeTips: false });
          } else {
            resolve({
              showWelcomeTips: true,
              createdCampaign: data.HasCampaigns,
              skippedBothAtAccountCreation: options.skippedBothAtAccountCreation,
              skippedNoneAtAccountCreation: options.skippedNoneAtAccountCreation,
            });
          }
        }).catch(() => {
          resolve({ showWelcomeTips: false });
        });
      }
    });

    welcomeStatus.then((status) => {
      if (cancel) {
        return;
      }
      if (status.showWelcomeTips) {
        // for the users we show welcome tips, set overview tab as default.
        preference.set({
          Name: 'OverviewAsDefaultTab',
          Data: true,
        });
      } else if (!doNotShowWelcomeTips) {
        // status changed. We will not show welcome tips for this user anymore.
        // option clean up
        const newOptions = _.omit(options, ['skippedBothAtAccountCreation', 'doneWithWelcomeTips', 'skippedNoneAtAccountCreation']);
        saveDashBoardOptions(newOptions);

        instrumentation.startScenario(instrumentationSettings.SCENARIONAME.LoadOverviewPage);
        instrumentation.startActivity(instrumentationSettings.ACTIVITYNAME.LoadOverviewPage);
        instrumentation.logMessage([constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO, 'overview', 'No welcomeTips for this user anymore.');

        preference.setAtUserLevel({
          Name: userWelcomePrefName,
          Data: true,
        });
      }
      setWelcomeTipsStatus(status);

      // eslint-disable-next-line no-unused-expressions
      () => {
        cancel = true;
      };
    });
  }, [WelcomeStatus, constants, instrumentation, navigationLevel, options, preference, saveDashBoardOptions, userWelcomePref, welcomeTipsStatus]);

  return welcomeTipsStatus;
};
